export default "__VITE_ASSET__b6b7744c__"